export const SET_CONTENT = 'SET_CONTENT'
export const SET_PROGRAM = 'SET_PROGRAM'
export const SET_MODAL = 'SET_MODAL'
export const SET_CONTEST_MSG = 'SET_CONTEST_MSG'
export const SET_VOLUNTAR_FORM_STATE = 'SET_VOLUNTAR_FORM_STATE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js